import { mapGetters } from 'vuex'

export const textVariables = {
  computed: {
    ...mapGetters(['mariaCampaign']),
    variables() {
      return ['[primeiro nome]', '[ultimo nome]', '[data hoje]', '[dia aniversario]', '[mes]', ']']
    },
    superVariables() {
      const offerType = this.mariaCampaign && this.mariaCampaign.offerType ? this.mariaCampaign.offerType : 'general'
      const product = offerType !== 'combo' ? 'produto' : 'combo'
      return [`[primeiro melhor ${product} `, `[segundo melhor ${product} `, `[terceiro melhor ${product} `]
    },
    insideVariables() {
      const offerType = this.mariaCampaign && this.mariaCampaign.offerType ? this.mariaCampaign.offerType : 'general'
      switch (offerType) {
        case 'general':
          return ['{nome produto}', '{preço 1}', '{preço 2}', '{inicio validade}', '{fim validade}']
        case 'percentage':
          return ['{nome produto}', '{desconto}', '{inicio validade}', '{fim validade}']
        case 'takepay':
          return ['{nome produto}', '{leve}', '{pague}', '{inicio validade}', '{fim validade}']
        case 'combo':
          return ['{nome produto}', '{nome do combo}', '{inicio validade}', '{fim validade}']
      }
    },
  },
  methods: {
    getRevisedText(text) {
      if (text) {
        const offerType = this.mariaCampaign && this.mariaCampaign.offerType ? this.mariaCampaign.offerType : 'general'
        let theBestProductsRegex
        if (offerType !== 'combo') {
          theBestProductsRegex = [
            text.match(/(\[primeiro melhor produto )[^\][]*(])/g),
            text.match(/(\[segundo melhor produto )[^\][]*(])/g),
            text.match(/(\[terceiro melhor produto )[^\][]*(])/g),
          ].filter((rx) => rx)
        } else {
          theBestProductsRegex = [
            text.match(/(\[primeiro melhor combo )[^\][]*(])/g),
            text.match(/(\[segundo melhor combo )[^\][]*(])/g),
            text.match(/(\[terceiro melhor combo )[^\][]*(])/g),
          ].filter((rx) => rx)
        }

        let variablesRegex = text.match(/(\[)[^\][]*(])/g)

        const verifyInsideVariables = (bestRegex) => {
          if (variablesRegex) {
            variablesRegex.forEach((matchVariables) => {
              if (!theBestProductsRegex.find((bx) => bx.includes(matchVariables))) {
                let variablesFormatted = matchVariables
                let variables = [...this.variables, ...this.superVariables]
                variables.forEach((variable) => {
                  if (!variablesRegex.includes(variable)) {
                    if (bestRegex) {
                      if (!bestRegex[0] !== matchVariables) {
                        variablesFormatted = variablesFormatted.replaceAll(
                          variablesFormatted,
                          `<span class="variable-error-super">${variablesFormatted}</span>`
                        )
                      }
                    }
                    variablesFormatted = variablesFormatted.replaceAll(variablesFormatted, `<span class="variable-error-super">${variablesFormatted}</span>`)
                  }
                })
                text = text.replaceAll(matchVariables, variablesFormatted)
              }
            })
          }

          if (bestRegex) {
            bestRegex.forEach((matchBest) => {
              const insideVariablesRegex = matchBest.match(/(\{)[^}{]*(})/g)
              if (insideVariablesRegex) {
                insideVariablesRegex.forEach((matchInsideVariables) => {
                  this.insideVariables.forEach((insideVariables) => {
                    let insideVariablesFormatted = matchInsideVariables
                    if (!matchInsideVariables.includes(insideVariables)) {
                      insideVariablesFormatted = insideVariablesFormatted.replaceAll(
                        insideVariablesFormatted,
                        `<span class="variable-error">${insideVariablesFormatted}</span>`
                      )
                    }
                    text = text.replaceAll(matchInsideVariables, insideVariablesFormatted)
                  })
                })
              }
            })
          }
        }

        if (theBestProductsRegex.length) theBestProductsRegex.forEach((bestRegex) => verifyInsideVariables(bestRegex))
        else {
          if (variablesRegex) {
            variablesRegex.forEach((matchVariables) => {
              let variablesFormatted = matchVariables
              let variables = [...this.variables, ...this.superVariables]
              variables.forEach((variable) => {
                if (!variablesRegex.includes(variable)) {
                  variablesFormatted = variablesFormatted.replaceAll(variablesFormatted, `<span class="variable-error">${variablesFormatted}</span>`)
                }
              })
              text = text.replaceAll(matchVariables, variablesFormatted)
            })
          }
        }

        const includeInsideVariables = theBestProductsRegex.length ? this.insideVariables : []

        if (text) {
          ;[...this.variables, ...this.superVariables, ...includeInsideVariables].forEach((matchVariables) => {
            text = text.replaceAll(matchVariables, `<span class="variable-highlight">${matchVariables}</span>`)
          })
        }
      }
      return text
    },
  },
}
